/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, ReactElement, SyntheticEvent, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Social } from './partials/social'
import InputField from './partials/input-field'

const HOST = process.env.REACT_APP_API_HOST

export interface LoginFormValues {
  login: string
  password: string
  remember: boolean
}

interface LoginFormProps {
  error: string
  isLanding: boolean
  isLoading: boolean
  handleSubmit: (values: LoginFormValues) => void
  handleSignupLink: (e: SyntheticEvent) => void
  handleForgotPasswordLink: (e: SyntheticEvent) => void
}

export const LoginForm: FC<LoginFormProps> = ({
  error,
  isLanding = true,
  isLoading = false,
  handleSubmit,
  handleSignupLink,
  handleForgotPasswordLink,
}): ReactElement => {
  const [isPassword, setIsPassword] = useState(true)

  const LoginSchema = Yup.object().shape({
    login: Yup.string().required(),
    password: Yup.string().required(),
    remember: Yup.bool(),
  })

  const formik = useFormik<LoginFormValues>({
    initialValues: {
      login: '',
      password: '',
      remember: false,
    },
    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      handleSubmit(values)
    },
  })

  return (
    <>
      {error && (
        <div className="hbMessage">
          <div className="wrapperHb">
            <span>!</span>
            <p>{error}</p>
          </div>
        </div>
      )}

      <div className={`form ${isLanding ? 'iframe' : ''}`}>
        <div className="wrapper">
          <div className="form-logo">
            <a href={HOST}>
              <img
                src="/account/img/header/logo-big.svg"
                width="231"
                height="32"
                alt=""
              />
            </a>
          </div>
          <p>
            New to Practithink?{' '}
            <a href="#" onClick={handleSignupLink}>
              Create an account
            </a>
          </p>
          <h2 className="form-title">Sign In</h2>

          <form autoComplete="off" onSubmit={formik.handleSubmit}>
            <InputField formik={formik} name="name">
              <label htmlFor="m-1">Email, User name or Account #</label>
              <input
                id="m-1"
                type="text"
                name="login"
                placeholder="Example: email@domain.com"
                onChange={formik.handleChange}
                value={formik.values.login}
              />
            </InputField>

            <InputField formik={formik} name="password">
              <div className="input-block__top">
                <label htmlFor="m-2">Password</label>
                <span
                  className="btn-show"
                  style={{ userSelect: 'none' }}
                  onClick={() => {
                    setIsPassword(!isPassword)
                  }}
                >
                  {isPassword ? 'Show' : 'Hide'}
                </span>
              </div>
              <input
                id="m-2"
                type={isPassword ? 'password' : 'text'}
                name="password"
                placeholder="Password"
                onChange={formik.handleChange}
                value={formik.values.password}
              />
            </InputField>

            {isLoading ? (
              <button type="button" disabled className="primary-btn">
                Submitting
              </button>
            ) : (
              <button type="submit" className="primary-btn">Sign in</button>
            )}

            <div className="form-checkbox">
              <div className="checkbox">
                <input
                  name="remember"
                  type="checkbox"
                  value="1"
                  onChange={formik.handleChange}
                  checked={formik.values.remember}
                />
                <span className="checkbox-ico" />
                <p>Keep me signed in</p>
              </div>
              <a href="#" onClick={handleForgotPasswordLink}>
                Forgot password?
              </a>
            </div>

            <Social />
          </form>
        </div>
      </div>
    </>
  )
}
